export default "/8522fe2631ecefb1e3967be9883671f05392a386/d9f26165e744ef064b81249371ce3c44.svg";